<template>
  <div class="wrapper">
    <div class="content-logo">
      <div class="logo">
        <img :src="logo" alt v-if="logo"/>
      </div>
      <div class="company-name">{{ companyName }}</div>
    </div>
    <div class="scan-num">
      <div class="scan-box-left">
        <p>扫描次数</p>
        <p>
          <span>{{ unit }}</span
          >次
        </p>
        <p>追溯码 {{ code }}</p>
      </div>
      <div class="scan-box-right">
        <div id="qrcode" class="qr-code"></div>
      </div>
    </div>
    <div class="content-details">
      <ul>
        <li>
          <p class="li-label">产品名称</p>
          <p class="li-name">{{ productName }}</p>
        </li>
        <li>
          <p class="li-label">规格</p>
          <p class="li-name">{{ specifications }}</p>
        </li>
        <li v-for="item in propertyDetailsList" :key="item.id">
            <p class="li-label">{{ item.propertyName }}</p>
            <p class="li-name li-img" v-if="item.propertyType==3">
              <img :src="item.propertyValue"/>
            </p>
            <p class="li-name" v-else>
              <span v-if="item.propertyType == 4">{{ item.propertyValue | dateformat }}</span>
              <span v-else>{{ item.propertyValue }}</span>
            </p>
        </li>
        <li>
          <p class="li-label">生产商</p>
          <p class="li-name">{{ companyName }}</p>
        </li>
        <!-- <li>
          <p class="li-label">生产日期</p>
          <p class="li-name">{{madeDate | dateformat}}</p>
        </li> -->
        <li>
          <p class="li-label">地址</p>
          <p class="li-name">{{ address }}</p>
        </li>
        <li>
          <p class="li-label">网址</p>
          <p class="li-name">{{ website }}</p>
        </li>
        <!-- <li>
          <p class="li-label">服务电话</p>
          <p class="li-name">{{}}</p>
        </li> -->
      </ul>
    </div>
    <div class="other-info-box">
      <ul>
        <li>
          <img
            src="../image/scan0/company-info-icon.png"
            @click="companyTab(1)"
          />
          <p>企业信息</p>
        </li>
        <li>
          <img src="../image/scan0/brand-icon.png" @click="companyTab(2)" />
          <p>品牌推广</p>
        </li>
        <li>
          <img
            src="../image/scan0/trace-code-icon.png"
            @click="companyTab(3)"
          />
          <p>溯源信息</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import QRCode from "qrcodejs2";
export default {
  components: {},
  props: {},
  data() {
    return {
      code: "",
      logo: "",
      companyName: "",
      unit: "",
      propertyDeploy: [],
      address: "",
      productName: "",
      productTypeName: "",
      madeDate: "",
      website: "",
      productName: "",
      productName: "",
      propertyDetailsList: [],
      specifications: "",
    };
  },
  watch: {},
  computed: { ...mapState(["codeInfo"]) },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     // 通过 `vm` 访问组件实例
  //     console.log(from);
  //     if (from.path == "/") {
  //       vm.getLocation();
  //     } else {
  //       vm.code = from.params.id;
  //       vm.setPageData(vm.codeInfo);
  //     }
  //   });
  // },
  methods: {
    // goWechat() {
    //   window.location.href =
    //     "https://test.jfwechat.chengquan.cn//integralMallRedirect?sessionId=59427186529107247_244_Klqca7&pageName=%2FintegralMall_v2%2Findex";
    // },
    //生成二维码
    qrcode(code) {
      document.getElementById("qrcode").innerHTML = "";
      let qrcode = new QRCode("qrcode", {
        width: 100,
        height: 100,
        colorDark: "#b0823b",
      });
      qrcode.clear();
      qrcode.makeCode(code);
    },
    companyTab(id) {
      switch (id) {
        case 1:
          this.$router.push("/scan-companyInfo/" + this.code);
          break;
        case 2:
          this.$router.push("/scan-branding/" + this.code);
          break;
        case 3:
          this.$router.push("/scan-traceability/" + this.code);
          break;
      }
    },
    getUrlParam(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  },
  created() {},
  mounted() {
    (function (win, lib) {
      var doc = win.document;
      var docEl = doc.documentElement;
      var metaEl = doc.querySelector('meta[name="viewport"]');
      var flexibleEl = doc.querySelector('meta[name="flexible"]');
      var dpr = 0;
      var scale = 0;
      var tid;
      var flexible = lib.flexible || (lib.flexible = {});

      if (metaEl) {
        console.warn("将根据已有的meta标签来设置缩放比例");
        var match = metaEl
          .getAttribute("content")
          .match(/initial\-scale=([\d\.]+)/);
        if (match) {
          scale = parseFloat(match[1]);
          dpr = parseInt(1 / scale);
        }
      } else if (flexibleEl) {
        var content = flexibleEl.getAttribute("content");
        if (content) {
          var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
          var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
          if (initialDpr) {
            dpr = parseFloat(initialDpr[1]);
            scale = parseFloat((1 / dpr).toFixed(2));
          }
          if (maximumDpr) {
            dpr = parseFloat(maximumDpr[1]);
            scale = parseFloat((1 / dpr).toFixed(2));
          }
        }
      }

      if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
          // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
          if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
            dpr = 3;
          } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
            dpr = 2;
          } else {
            dpr = 1;
          }
        } else {
          // 其他设备下，仍旧使用1倍的方案
          dpr = 1;
        }
        scale = 1 / dpr;
      }

      docEl.setAttribute("data-dpr", dpr);
      if (!metaEl) {
        metaEl = doc.createElement("meta");
        metaEl.setAttribute("name", "viewport");
        metaEl.setAttribute(
          "content",
          "initial-scale=" +
            scale +
            ", maximum-scale=" +
            scale +
            ", minimum-scale=" +
            scale +
            ", user-scalable=no"
        );
        if (docEl.firstElementChild) {
          docEl.firstElementChild.appendChild(metaEl);
        } else {
          var wrap = doc.createElement("div");
          wrap.appendChild(metaEl);
          doc.write(wrap.innerHTML);
        }
      }

      function refreshRem() {
        var width = docEl.getBoundingClientRect().width;
        if (width / dpr > 540) {
          width = 540 * dpr;
        }
        var rem = width / 10;
        docEl.style.fontSize = rem + "px";
        flexible.rem = win.rem = rem;
      }

      win.addEventListener(
        "resize",
        function () {
          clearTimeout(tid);
          tid = setTimeout(refreshRem, 300);
        },
        false
      );
      win.addEventListener(
        "pageshow",
        function (e) {
          if (e.persisted) {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
          }
        },
        false
      );

      if (doc.readyState === "complete") {
        doc.body.style.fontSize = 12 * dpr + "px";
      } else {
        doc.addEventListener(
          "DOMContentLoaded",
          function (e) {
            doc.body.style.fontSize = 12 * dpr + "px";
          },
          false
        );
      }

      refreshRem();

      flexible.dpr = win.dpr = dpr;
      flexible.refreshRem = refreshRem;
      flexible.rem2px = function (d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === "string" && d.match(/rem$/)) {
          val += "px";
        }
        return val;
      };
      flexible.px2rem = function (d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === "string" && d.match(/px$/)) {
          val += "rem";
        }
        return val;
      };
    })(window, window["lib"] || (window["lib"] = {}));

    var url = window.location.href;
    var index = url.lastIndexOf("/");
    var str = url.substring(index + 1, url.length);
    str = str.split("?")[0];
    this.code = str;
    this.qrcode(str);
    this.logo = this.codeInfo.companyInfo
      ? this.codeInfo.companyInfo.companyLogo
      : "";
    this.address = this.codeInfo.companyInfo
      ? this.codeInfo.companyInfo.address
      : "";
    this.companyName = this.codeInfo.companyName;
    this.unit = this.codeInfo.unit;
    this.propertyDeploy = this.codeInfo.propertyDeploy
      ? this.codeInfo.propertyDeploy
      : [];
    this.productName = this.codeInfo.productName;
    this.specifications = this.codeInfo.specifications;
    this.propertyDetailsList = this.codeInfo.propertyDetailsList;
    this.website = this.codeInfo.companyInfo
      ? this.codeInfo.companyInfo.companyInfoIntroduction.website
      : "";
  },
};
</script>
<style lang="less" scoped>
@base: 40;

.wrapper {
  html {
    font-size: 20px;
  }
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  background-color: #ffffff;
  .content-logo {
    overflow: hidden;
    .logo {
      width: 25%;
      margin: 8% auto 3%;
      img {
        width: 100%;
      }
    }
    .company-name {
      font-size: 1rem / @base * 16;
      text-align: center;
      width: 80%;
      margin: 0 auto;
      color: #b0823b;
    }
  }
  .scan-num {
    width: 90%;
    margin: 5%;
    border-radius: 0.5rem;
    box-shadow: 0 0 10px #e0e0e0;
    padding: 20rem / @base 0;
    display: flex;
    .scan-box-left,
    .scan-box-right {
      width: 50%;
      display: inline-block;
      vertical-align: top;
    }
    .scan-box-left {
      p {
        padding-left: 30rem / @base;
        color: #60605f;
        font-size: 1rem / @base * 14;
        margin-bottom: 15px;
        span {
          font-size: 1rem / @base * 30;
          color: #cd9e5c;
          margin-right: 5px;
          font-weight: bold;
        }
      }
      p:nth-child(3) {
        margin-bottom: 0;
      }
    }
    .scan-box-right {
      .qr-code {
        text-align: center;
        /deep/img {
          display: inline-block !important;
        }
      }
    }
  }
  .content-details {
    ul {
      width: 80%;
      margin: 0 auto;
      li {
        display: flex;
        width: 100%;
        margin-top: 20px;
        .li-label {
          width: 80px;
          font-size: 1rem / @base * 15;
          color: #60605f;
        }
        .li-name {
          width: calc(100% - 80px);
          text-align: right;
          font-size: 1rem / @base * 16;
          color: #343434;
        }
        .li-img{
          img{
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
  .advice {
    width: 80%;
    margin: 0 auto;
    margin-top: 10px;
    color: red;
  }
  .other-info-box {
    width: 100%;
    margin: 0 auto;
    ul {
      display: flex;
      justify-content: space-around;
      margin-top: 20px;
      margin-bottom: 50px;
      li {
        padding: 20rem / @base 0;
        text-align: center;
        width: 30%;
        border-radius: 12rem / @base;
        background-color: #fbf7f3;
        p {
          font-size: 1rem / @base * 17;
          margin-top: 10px;
          color: #b0823b;
        }
        img {
          width: 70%;
        }
      }
    }
  }

  .content {
    margin-top: 8rem / @base;
    .logo {
      width: 100%;
      text-align: center;
      background-color: #fff;
      img {
        width: 50%;
      }
    }
    .info {
      margin-top: 8rem / @base;
      background-color: #fff;
      padding-left: 35rem / @base;
      .l1 {
        padding: 20rem / @base 0 0;
        display: flex;
        align-items: baseline;
        &:last-child {
          padding-bottom: 20rem / @base;
        }
        span {
          color: #343434;
          font-size: 1rem / @base * 16;
        }
        .s1 {
          width: 31%;
          text-align: left;
        }
        .btn {
          width: 150rem / @base;
          height: 50rem / @base;
          background-image: url("../image/scan/btnbg.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          text-align: center;
          color: #fff;
          line-height: 40rem / @base;
        }
      }
    }
    .productInfo {
      margin-top: 8rem / @base;
      background-color: #fff;
      padding: 0 30rem / @base 0 30rem / @base;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12rem / @base 0;
        border-bottom: 1px solid #f1f1f1;
        font-size: 1rem / @base * 15 !important;
        .left {
          display: flex;
          align-items: center;
          .line {
            height: 30rem / @base;
            width: 5rem / @base;
            background-color: #1375d2;
            margin-right: 6rem / @base;
          }
          .text {
            font-size: 1rem / @base * 18;
          }
        }
        .right {
          img {
            width: 20rem / @base;
            height: 20rem / @base;
            transform: rotate(0deg);
            transition: transform 0.5s;
          }
          .active {
            transform: rotate(180deg);
            transition: transform 0.5s;
          }
        }
      }
      .box {
        .companyInfo {
          line-height: 1rem / @base * 24;
          padding: 10rem / @base 0;
        }
        .l1 {
          padding: 20rem / @base 0 0;
          display: flex;
          align-items: baseline;
          &:last-child {
            padding-bottom: 20rem / @base;
          }
          span {
            color: #343434;
            font-size: 1rem / @base * 16;
          }
          .s1 {
            width: 31%;
            text-align: left;
          }
          .index {
            width: 100%;
            font-size: 1rem / @base * 18;
            font-weight: bold;
            color: #1375d2;
            border-bottom: 1px solid #f1f1f1;
            padding: 15rem / @base 0;
          }
          .activeIndex {
            border-top: 1px solid #f1f1f1;
          }
        }
        .textwrap {
          .image {
            width: 60%;
            display: block;
            margin: 20rem / @base auto;
          }
          .text {
            line-height: 1rem / @base * 24;
            text-indent: 2em;
            padding-bottom: 10rem / @base;
            font-size: 1rem / @base * 15 !important;
          }
        }
      }
    }
  }
  .nohave {
    padding: 0 1rem / @base * 15;
    .title {
      font-size: 1rem / @base * 22;
    }
    .info {
      margin-top: 1rem / @base * 20;
      display: flex;
      .image {
        width: 1rem / @base * 40;
        height: 1rem / @base * 40;
        margin-right: 1rem / @base * 30;
        img {
          width: 100%;
        }
      }
      .code {
        p {
          color: red;
          font-size: 1rem / @base * 16;
          margin-bottom: 1rem / @base * 15;
        }
        .line {
          width: 100%;
          height: 1px;
          border: 1px solid #eee;
        }
        .tishi {
          margin-top: 1rem / @base * 15;
          color: royalblue;
          font-size: 1rem / @base * 16;
        }
      }
    }
  }
  .footer {
    text-align: left;
    padding: 10rem / @base 0;
    display: inline-block;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    .text1 {
      font-size: 1rem / @base * 12;
      color: #004281;
      .footer-label {
        .title-top {
          vertical-align: top;
          width: 1rem / @base * 75;
        }
        p {
          vertical-align: top;
          font-size: 1rem / @base * 15;
        }
        div {
          vertical-align: top;
          font-size: 1rem / @base * 15;
          display: inline-block;
        }
      }
    }
    .text2 {
      font-size: 1rem / @base * 12;
      .footer-label {
        .title-top {
          width: 1rem / @base * 75;
          vertical-align: top;
        }
        p {
          vertical-align: top;
          font-size: 1rem / @base * 15;
        }
        div {
          vertical-align: top;
          font-size: 1rem / @base * 15;
          display: inline-block;
        }
      }
    }
  }
  .maskInfo {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    overflow-y: auto;
    z-index: 100;
    .close {
      width: 1rem / @base * 40;
      height: 1rem / @base * 40;
      line-height: 1rem / @base * 40;
      text-align: center;
      position: absolute;
      right: 24rem / @base;
      top: 0;
      color: #343434;
      img {
        width: 2rem / @base * 8;
      }
    }
    .textwrap {
      width: 80%;
      position: absolute;
      top: 10%;
      left: 0;
      right: 0;
      margin: auto;
      background: #fff;
      padding: 20rem / @base;
      border-radius: 15rem / @base;
      margin-bottom: 25rem / @base;
      div {
        line-height: 1rem / @base * 32;
        text-indent: 2em;
        font-size: 1rem / @base * 18;
        text-align: justify;
      }
    }
  }
  .mask {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    #biao1 {
      color: #38adff;
    }
    .cdkey {
      width: 70%;
      height: 1rem / @base * 240;
      position: absolute;
      top: 20%;
      left: 0;
      right: 0;
      margin: auto;
      background: #fff;
      padding: 1rem / @base * 10;
      .title {
        font-size: 1rem / @base * 18;
        color: red;
      }
      p {
        margin-bottom: 1rem / @base * 20;
        span {
          color: red;
        }
      }
      .el-button {
        float: right;
      }
      .close {
        width: 1rem / @base * 40;
        height: 1rem / @base * 40;
        line-height: 1rem / @base * 40;
        text-align: center;
        background: rgba(0, 0, 0, 0.4);
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
}
.wmassageMask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 101;
  display: flex;
  justify-content: center;
  .messageMaskContent {
    position: absolute;
    top: 20%;
    width: 85%;
  }
  .cash_bonus_title {
    position: absolute;
    top: 25%;
    color: #fddeab;
    text-align: center;
    p {
      font-size: 1rem / @base * 18;
    }
    .cash_mount {
      font-size: 1rem / @base * 36;
      font-weight: bolder;
      margin-top: 7.5rem / @base;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/scan0.vue